import { render, staticRenderFns } from "./soldlist.vue?vue&type=template&id=19c34a40&scoped=true"
import script from "./soldlist.vue?vue&type=script&lang=js"
export * from "./soldlist.vue?vue&type=script&lang=js"
import style0 from "./soldlist.vue?vue&type=style&index=0&id=19c34a40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c34a40",
  null
  
)

export default component.exports